import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { IdParam } from '../../models/gen/idParam';
import { WorkApplyParam } from '../../models/gen/workApplyParam';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const WORK_APPLY_CONTEXT_NAMES = {
  POST_WORK_APPLY_APPLY: 'applyWorkApply',
  POST_WORK_APPLY_PUBLISH_CONFIRM: 'confirmPublishedWorkApply',
} as const;

const apis = apiGenerator();

/**
 * POST /work-apply/apply
 *
 * @param param -
 * @returns
 */
export const usePostWorkApplyApply = () =>
  useGenericMutation(async (param: WorkApplyParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/work-apply/apply`, {
      ...queryOptions,
      data: param,
    })
  );

/**
 * POST /work-apply/publish/confirm
 *
 * @param param -
 * @returns
 */
export const usePostWorkApplyPublishConfirm = () =>
  useGenericMutation(async (param: IdParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/work-apply/publish/confirm`, {
      ...queryOptions,
      data: param,
    })
  );
